import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LoginRequired } from '../../../hoc/LoginRequired.jsx';
import notifier from '../../../../../components/notifier';
import { createPaymentData } from '../../../actions/payment-data';
import PaymentDataForm from './PaymentDataForm.jsx';


const PaymentDataCreateForm = ({ createPaymentData }) => {

  const handleFormSubmit = async (formData) => {
    const response = await createPaymentData(formData);
    if (response) {
      notifier.success(gettext('Платежная информация успешно добавлена.'));
    }
  };

  return <PaymentDataForm onSubmit={ handleFormSubmit }/>
};

PaymentDataCreateForm.PropTypes = {
  createPaymentData: PropTypes.func.isRequired,
}

export default compose(
  connect(null, { createPaymentData }),
  LoginRequired,
)(PaymentDataCreateForm);
